import React from 'react';
import DataTableComponent, { TableProps } from 'react-data-table-component';
import type { TableStyles } from "react-data-table-component";

const customStyles: TableStyles = {
  table: {
    style: { backgroundColor: "transparent" },
  },
  headRow: {
    style: {
      backgroundColor: "transparent",
      borderBottomColor: "rgba(255,255,255,0.12)",
      borderBottomStyle: "solid",
      borderBottomWidth: "1px",
    },
  },
  headCells: {
    style: {
      color: "rgba(255,255,255,0.7)",
      fontSize: "12px",
      textTransform: "uppercase",
      letterSpacing: "0.06em",
    },
  },
  rows: {
    style: {
      backgroundColor: "transparent",
      color: "rgba(255,255,255,0.88)",
      fontSize: "13px",
      minHeight: "52px",
      borderBottomStyle: "solid",
      borderBottomColor: "rgba(255,255,255,0.08)",
      borderBottomWidth: "1px",
    },
    highlightOnHoverStyle: {
      backgroundColor: "rgba(255,255,255,0.07)",
      color: "rgba(255,255,255,1)",
      borderBottomColor: "rgba(255,255,255,0.15)",
      outline: "none",
    },
  },
  pagination: {
    style: {
      backgroundColor: "transparent",
      color: "rgba(255,255,255,0.7)",
      borderTopStyle: "solid",
      borderTopColor: "rgba(255,255,255,0.10)",
      borderTopWidth: "1px",
    },
    pageButtonsStyle: {
      color: "rgba(255,255,255,0.7)",
      fill: "rgba(255,255,255,0.7)",
      "&:disabled": {
        color: "rgba(255,255,255,0.2)",
        fill: "rgba(255,255,255,0.2)",
      },
      "&:hover:not(:disabled)": {
        backgroundColor: "rgba(255,255,255,0.08)",
      },
    },
  },
};

export default function DataTable<T>(props: TableProps<T>) {
  return (
    <DataTableComponent
      dense
      fixedHeader
      fixedHeaderScrollHeight="calc(100vh - 320px)"
      highlightOnHover
      pointerOnHover
      customStyles={customStyles}
      {...props}
    />
  );
}